(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stelar-countdown')) {
    class StelarCountdown extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end).getTime();
        if (Number.isNaN(this.end)) return;
        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const diff = this.end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          if (this.dataset.hideExpired === 'true') {
            this.dataset.expired = 'true';
          } else {
            this.render(0, 0, 0, 0);
          }
          return;
        }
        const seconds = Math.floor(diff / 1000);
        this.render(
          Math.floor(seconds / 86400),
          Math.floor((seconds % 86400) / 3600),
          Math.floor((seconds % 3600) / 60),
          seconds % 60
        );
      }

      render(d, h, m, s) {
        const pad = (n) => String(n).padStart(2, '0');
        if (this.units.days) this.units.days.textContent = pad(d);
        if (this.units.hours) this.units.hours.textContent = pad(h);
        if (this.units.minutes) this.units.minutes.textContent = pad(m);
        if (this.units.seconds) this.units.seconds.textContent = pad(s);
      }
    }
    customElements.define('stelar-countdown', StelarCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
